import { storeToRefs } from 'pinia'

import { useProfileQuery, usePatchProfile, useRequestEmailChange } from '@/queries/users'
import { useUsersStore } from '@/stores/users'

export function useUser() {
  const usersStore = useUsersStore()
  const profileQuery = useProfileQuery()
  const patchProfileMutation = usePatchProfile()
  const requestEmailChangeMutation = useRequestEmailChange()

  return {
    ...storeToRefs(usersStore),
    profileQuery,
    isFetchingProfile: profileQuery.isFetching,
    patchProfileMutation,
    requestEmailChangeMutation,
  }
}
